export const SET_HEADER_PREVIEW = "SET_HEADER_PREVIEW";
export const SET_HEADER_PREVIEW_RESET = "SET_HEADER_PREVIEW_RESET";
